import { useSearchParams } from "react-router-dom";
import ListBox from "../ui-lib/ListBox";
import { useTeachers } from "../../states/cache-state/useTeachers";
import { useQuery } from "react-query";
import useAuthData from "../../auth/useAuthData";
import { HTMLProps } from "react";
import classNames from "classnames";
import { QueryParamNames } from "../../models/enums/query-param-names";
import Label from "../ui-lib/Label";

function VacancyFilters(params: HTMLProps<HTMLDivElement>) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { getTeachersOfSchool } = useTeachers();
  const { currentSchool } = useAuthData();
  const { data: teachers } = useQuery(
    ["teachers", currentSchool?.id],
    () => getTeachersOfSchool(currentSchool!.id, false),
    { enabled: !!currentSchool },
  );
  return (
    <div className={classNames("flex gap-2", params.className)} {...params}>
      {teachers && (
        <Label
          text="Filter"
          position="top"
          labelClass="mb-2 uppercase font-bold text-th-primary-900"
        >
          <ListBox
            className="md:w-56"
            values={teachers}
            itemDisabled={() => false}
            name="absentTeacher"
            valueIdentifier={(t) => t.id}
            valueKey={(t) => t.fullName}
            showClearValue={true}
            valueChanged={(t) =>
              setSearchParams((p) => {
                !!t
                  ? p.set(QueryParamNames.absentTeacherId, t.id)
                  : p.delete(QueryParamNames.absentTeacherId);
                return p;
              })
            }
            value={teachers.find(
              (t) => t.id === searchParams.get(QueryParamNames.absentTeacherId),
            )}
            placeholder="Lehrperson"
          ></ListBox>
        </Label>
      )}
    </div>
  );
}

export default VacancyFilters;
